<template>
  <div>
    <router-view v-wechat-title='$route.meta.title'></router-view>
    <div class="pre_img_tip">长按处方笺，可将处方笺保存到本地相册</div>
    <img :src="url" class="pre_img" preview="0" @click="showBigImg" >
  <van-image-preview
    v-model="show"
    :images="[url]"
  >
</van-image-preview>

  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  data(){
    return{
      url:"",
      show:false,
    }
  },
  methods:{
    showBigImg(){
      this.show = true
    },
onChange(e){
  console.log(e)
},
  },
  mounted(){
    window.watchs()
    this.url = JSON.parse(this.$route.query.url)
  }
}
</script>

<style lang="scss" scoped>
.pre_img{
  width: 100%;
  height: 100%;
}
.pre_img_tip{
  background-color: #FFF1E1;
  font-size: 14px;
  padding: 10px 20px;
  text-align: center;
  color: gray;
}
</style>

